const rules: { regex: RegExp; replace: string }[] = [
	{
		regex: /(\\*)?&quot;/g,
		replace: '"',
	},
	{
		regex: /&amp;/g,
		replace: '&',
	},
	{
		regex: /<\/?sup>/g,
		replace: '',
	},
	{
		regex: /\\/g,
		replace: '',
	},
	{
		regex: /‘|’/g,
		replace: "'",
	},
];

export function sanitizeText(input: string): string {
	// eslint-disable-next-line no-restricted-syntax
	for (const rule of rules) {
		input = input.replace(rule.regex, rule.replace);
	}
	return input;
}
